import { ComponentProps } from "react"
import styles from "./index.module.scss"





const Blobs = ({...props}: ComponentProps<"div">) => {
    return (
        <div {...props} className={styles.blobs + ` ${props.className ? props.className : ""}`} />
    )
}

export default Blobs